import { Heart, Phone, ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-blue-900 text-blue-100 mt-16">
      <div className="max-w-6xl mx-auto px-4 py-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="sm:col-span-2 lg:col-span-1 flex flex-col items-start">
          <img
            src="https://customer-assets.emergentagent.com/job_conecta-medicinas/artifacts/padqrbhb_Logo_CE_fondoBlanco.png"
            alt="Ciudad Enfermería"
            className="h-24 w-24 rounded-full bg-white p-1 shadow-md mb-3"
          />
          <h3 className="font-display text-xl font-semibold text-white">Ciudad Enfermería</h3>
          <p className="text-xs text-blue-300 mt-1">San Luis Potosí</p>
        </div>
        <div>
          <h4 className="font-display text-base font-semibold text-white">Nuestra misión</h4>
          <p className="mt-3 text-sm leading-relaxed text-blue-200">
            Cuidamos pacientes y ofrecemos servicios de enfermería.
            Esta plataforma busca poner orden y confianza en el intercambio de
            medicamentos entre familias.
          </p>
        </div>
        <div>
          <h4 className="font-display text-base font-semibold text-white flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-blue-300" /> Aviso importante
          </h4>
          <p className="mt-3 text-sm leading-relaxed text-blue-200">
            <strong className="text-white">Ciudad Enfermería NO almacena ni vende medicamentos.</strong>{" "}
            Sólo conectamos a quien ofrece con quien necesita. Verifica siempre
            la caducidad, el empaque y la procedencia antes de comprar.
          </p>
        </div>
        <div>
          <h4 className="font-display text-base font-semibold text-white flex items-center gap-2">
            <Phone className="w-5 h-5 text-blue-300" /> Contacto
          </h4>
          <p className="mt-3 text-sm leading-relaxed text-blue-200">
            Servicios de enfermería a domicilio<br/>
            <span className="text-white font-medium">contacto@ciudadenfermeria.com</span>
          </p>
        </div>
      </div>
      <div className="border-t border-blue-800 py-4">
        <p className="text-center text-xs text-blue-300 flex items-center justify-center gap-1.5">
          Hecho con <Heart className="w-3.5 h-3.5 text-blue-300 fill-blue-300" /> para nuestras familias.
        </p>
      </div>
    </footer>
  );
}
